export default {
  state: {
    list: [],
  },
  mutations: {
  },
  actions: {
    fetchDepartments({ commit, state }, query) {
      return this._vm.$api.departments.fetchDepartments(query);
    },
  },
};
